import CartSummaryPresenter from "../components/cart-summary/presenter/cart-summary.js";

const items = [
  {
    quantity: document.querySelector(`.cart-order-summary__quantity`),
    totalPrice: document.querySelector(`.cart-order-summary__sum-value`)
  },
  {
    quantity: document.querySelector(`.cart-order-item__summary-quantity`),
    totalPrice: document.querySelector(`.cart-order-item__summary-price`)
  },
  {
    quantity: document.querySelector(`.category-products-quantity_cart`)
  }
];
const cartSummaryComponent = new CartSummaryPresenter(items);
cartSummaryComponent.init();
